import React, { useEffect, useState } from 'react';
import styles from './EmailsREceivedContainer.module.css';
import WhiteContainer from '../../../../HOC/WrappingContainer/WhiteContainer';
import NoDataComponent from '../../../Custom/NoData/NoDataComponent';
import InboxList from '../../../mail-page/inbox/inbox-list/InboxList';
import MailTemplateSent from '../../../mail-page/email-sent/MailTemplateSent';
import WrappingContainer from '../../../../HOC/WrappingContainer/WrappingContainer';
import SendMailContainer from '../../../mail-page/send-email/SendMailContainer';
import { useDeleteMail } from '../../../../../Hooks/Mail';
import { toast } from 'react-toastify';
import DeletePopup from '../../../Custom/DeletePopup';

const EmailsReceivedContainer = ({
  notifications,
  mails,
  setSelected,
  refetch,
}) => {
  const [reply, setReply] = useState({
    show: false,
    type: null,
    content: null,
  });
  const [isNewMail, setIsNewMail] = useState(false);
  const [selectedEmail, setSelectedEmail] = useState(null);
  const [isDelete, setIsDelete] = useState({
    id: null,
    show: false,
  });
  const { mutate: DeleteMail, isLoading } = useDeleteMail();

  const onDelete = (id) => {
    setIsDelete((prev) => ({
      ...prev,
      id: id,
      show: true,
    }));
  };
  const handleDelete = () => {
    DeleteMail(isDelete.id, {
      onSuccess: () => {
        if (isDelete.id === selectedEmail?.id) {
          setSelectedEmail(null);
        }
        setIsDelete({
          id: null,
          show: false,
        });
        console.log('VFDvfdfvd');
        refetch();
        setSelected('Emails');
        toast.success('Mail Deleted successfully');
      },
    });
  };
  return (
    <>
      {mails?.length > 0 ? (
        <>
          {/* <div className={styles['receivedEmail-container']}>
            <ReceivedEmailsList
              data={notifications}
              selectedEmail={selectedEmail}
              setSelectedEmail={setSelectedEmail}
            />
            <EmailsReceived email={selectedEmail} />
          </div>
          <div className={styles['receivedEmail_mobilecontainer']}>
            <MobileRecievedEmail data={notifications} />
          </div>{' '} */}

          <WrappingContainer className={styles['mailContainer']}>
            <div className={styles['inboxContainer']}>
              <div style={{ overflow: 'scroll' }}>
                <InboxList
                  setSelectedMail={setSelectedEmail}
                  selectedMail={selectedEmail}
                  mailInbox={mails?.map((m) => {
                    return {
                      ...m,
                      id: m.graphMessageId,
                    };
                  })}
                  onDelete={onDelete}
                  isEmail
                />
              </div>
            </div>
            <div className={styles.list}>
              <MailTemplateSent
                selectedMail={selectedEmail}
                setReply={setReply}
                isNewMail={isNewMail}
                setIsNewMail={setIsNewMail}
                onDelete={onDelete}
              />
            </div>
          </WrappingContainer>

          <SendMailContainer
            reply={reply}
            setReply={setReply}
            isNewMail={isNewMail}
            setIsNewMail={setIsNewMail}
          />
          {isDelete?.show && (
            <DeletePopup
              handleOnClose={() =>
                setIsDelete((prev) => ({
                  ...prev,
                  show: false,
                }))
              }
              title='Mail'
              handleDelete={handleDelete}
              isLoading={isLoading}
            />
          )}
        </>
      ) : (
        <WhiteContainer white>
          {/* <EmptyText text='Notifications' /> */}
          <NoDataComponent text='Mails' />
        </WhiteContainer>
      )}
    </>
  );
};

export default EmailsReceivedContainer;
